import { customAlphabet } from "nanoid";

// URL に出すため、紛らわしい文字を除いたアルファベットを使用する。
// 12 文字あれば衝突確率は十分低い（10^21 通り）。
const alphabet = "23456789abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
const generate = customAlphabet(alphabet, 12);

/**
 * 新規キャンバス ID を生成する。
 */
export function generateCanvasId(): string {
  return generate();
}

/**
 * URL のキャンバス ID として有効な文字列か判定する。
 * 自動生成キャンバスは 12 文字だが、外部システム（PO ボードのエピックなど）から
 * `epic-{UUIDv4}` 形式（41 文字）の ID を受け取るケースに対応するため上限を 64 文字とする。
 */
export function isValidCanvasId(value: string): boolean {
  return /^[A-Za-z0-9_-]{6,64}$/.test(value);
}
